<template>
  <v-app>
    <Navbar />
    <v-main class="primary">
      <transition name="slide-fade">
        <router-view :key="$route.path"></router-view
      ></transition>
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  name: "App",
  components: { Navbar },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
html {
  font-family: "PT Sans", Sans-Serif;
  margin: 0;
}

body {
  font-family: "Playfair Display", Serif;
  margin: 0;
}

::placeholder {
  color: black;
}

input {
  padding: 10px !important;
  width: 100%;
}

.buttons {
  width: 10%;
}

.orders {
  width: 100%;
  margin: 0;
}

.active {
  color: #b71c1c !important;
}

.tablediv {
  width: 100%;
  height: auto;
}
.content {
  height: 70vh;
  overflow: auto;
  padding-left: 2%;
  padding-right: 2%;
}
.pdfcontent {
  height: 70vh;
  overflow: auto;
  padding-left: 2%;
  padding-right: 2%;
}

div.tablediv > div > input[type="text"],
div.tablediv > div > input[type="number"],
div.tablediv > div > input[type="date"] {
  font-size: 1.2rem;
  font-family: "Playfair Display", Serif;
  border: solid gray;
}
p {
  clear: left !important;
}
iframe {
  width: 100%;
  height: 99%;
}
h1,
h2,
h3 {
  font-family: "PT Sans", Sans-Serif;
  letter-spacing: 1px;
  line-height: 160%;
}
p,
li {
  font-family: "Playfair Display", Serif;
  font-size: 1.2rem;
  letter-spacing: 1px;
  line-height: 150%;
  font-weight: 500;
}

li {
  padding-bottom: 15px !important;
}

.v-data-table-header th {
  white-space: nowrap;
}

.v-data-footer__pagination {
  display: none !important;
}

.v-btn {
  color: #b71c1c !important;
}

.v-data-footer__select,
div.v-data-footer > span,
.v-select__selections {
  color: #b71c1c;
  font-size: 1.1rem;
  font-weight: bold;
}

.v-select__selections,
.v-list-item__title {
  color: #b71c1c !important;
  font-size: 1.2rem !important;
}

.v-select__selections > div {
  color: #b71c1c !important;
  font-size: 1rem !important;
}

.v-input__append-inner .ck-content a:hover {
  background-color: #bbdefb !important;
}

.ck-content a {
  color: #3f51b5 !important;
  font-weight: bold;
}

.item-title {
  font-family: "Playfair Display", Serif !important;
  font-size: 1.3rem;
  line-height: 1.5;
  letter-spacing: 1px;
  line-height: 28px;
  font-weight: 500;
  color: black;
}
.project {
  cursor: pointer;
}
.title {
  font-family: "Playfair Display", Serif !important;
  letter-spacing: 1px;
  line-height: 160%;
}
.ck-editor__editable {
  min-height: 500px !important;
}
.ck-editor {
  min-height: 500px !important;
  width: 90% !important;
}
.project.Full {
  border-left: 6px solid #e98074;
}
.project.Buy {
  border-left: 6px solid #e85a4f;
}
.project.Wait {
  border-left: 6px solid #d8c3a5;
}
.v-chip.Full {
  background: #e98074 !important;
}
.v-chip.Buy {
  background: #e85a4f !important;
}
.v-chip.Wait {
  background: #d8c3a5 !important;
}
.img-click:hover {
  color: #424242;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  -ms-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  opacity: 1;
  transform: scale(4);
  -ms-transform: scale(4); /* IE 9 */
  -webkit-transform: scale(4); /* Safari and Chrome */
  z-index: 10;
}
.passform {
  border-style: groove;
  border: 2px solid red;
  height: 40px;
  cursor: pointer;
  padding-left: 10px;
}
.v-data-table {
  width: 80% !important;
}

@media only screen and (min-width: 100px) and (max-width: 2000px) {
  .v-data-table {
    width: 100% !important;
  }
}
</style>
